var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, isValidElement, cloneElement } from 'react';
import styled from 'styled-components';
import { StyledModal } from '../../styleguide/styles/modals';
var StyledWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  display: inline-block;\n  width: 100%;\n"], ["\n  cursor: pointer;\n  display: inline-block;\n  width: 100%;\n"])));
function ModalButton(props) {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    function toggleModal() {
        setIsOpen(!isOpen);
    }
    var contentWithProps = props.content;
    if (isValidElement(props.content))
        contentWithProps = cloneElement(props.content, {
            toggleModal: toggleModal,
        });
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledWrapper, { onClick: toggleModal }, props.children),
        React.createElement(StyledModal, { isOpen: isOpen, onBackgroundClick: toggleModal, onEscapeKeydown: toggleModal }, contentWithProps)));
}
export default ModalButton;
var templateObject_1;
